import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Button, Form, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import {ADD_EDIT_TAG} from '../../../gql/mutations/tagMutations'
import {IResAddTag} from '../../../types/tags'

interface IModalAddTags {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit?: null | {id: string; name: string; color: string}
}

export const ModalAddTag: React.FC<IModalAddTags> = ({isOpen, onClose, refetch, infoEdit}) => {
  const [gqlAddEditTag, {data, loading, error}] = useMutation<IResAddTag>(ADD_EDIT_TAG)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.tagInsuranceCreateupdateMutation?.tagInsurance?.id) {
      toast.success(`Success: Tag ${infoEdit ? 'edited correctly' : 'successfully added'}`)
      onClose()
      refetch()
    } else if (data.tagInsuranceCreateupdateMutation?.errors?.length > 0) {
      toast.error(
        `Error: ${
          data.tagInsuranceCreateupdateMutation?.errors?.[0]?.messages?.[0] || 'something happened'
        }`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {name, color} = Object.fromEntries(new FormData(e.currentTarget))
    gqlAddEditTag({
      variables: {
        input: {
          id: infoEdit ? parseId(infoEdit.id) : undefined,
          name,
          color,
        },
      },
    })
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{infoEdit ? 'Edit' : 'Add'} Tag</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
            <Form.Label>Tag name</Form.Label>
            <Form.Control
              type='text'
              name='name'
              defaultValue={infoEdit ? infoEdit.name : ''}
              required
              placeholder='Enter name'
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='inputcolor'>
            <Form.Label>Tag color</Form.Label>
            <Form.Control
              type='color'
              name='color'
              required
              defaultValue={infoEdit ? infoEdit.color : '#fff'}
              className='w-25'
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' variant='secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button
            type='submit'
            variant='primary'
            className='d-flex align-items-center'
            disabled={loading}
          >
            {loading && <Spinner animation='border' size='sm' />}
            Save Changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
